(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('recentSearches', function(savedSearchService, basketService, analytics) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'partials/home/directivetemplate?type=RecentSearches',
        scope: {
            maxItems: '@',
            searchType: '='
        },
        link(scope) {
            scope.busy = false;

            scope.$on('auth:signout', load);

            function load(searchType) {
                savedSearchService.getSavedSearches(searchType).then(function(searches) {
                    //scope.searches = scope.maxItems ? searches.slice(0, scope.maxItems) : searches;
                    /// If trying to load only specific type of search, but it returns empty, repeat search without type
                    if (searchType && !searches.length) {
                        load();
                    } else {
                        scope.searches = searches;
                    }
                });
            }
            load(scope.searchType);

            scope.restoreSearch = function(s) {
                if (!scope.busy) {
                    scope.selectedId = s.SavedSearchId;
                    scope.busy = true;

                    savedSearchService.restoreSearch(s).then(function() {
                        basketService.startWorkflow(basketService.workflowType[s.SearchType]).then(() => scope.busy = false,
                            () => scope.busy = false);
                        analytics.trackEvent({ label: 'restore saved search' });
                    }, function() {
                        scope.busy = false;
                    });
                }
            };

            scope.deleteSearch = function(ev, s) {
                ev.preventDefault();
                ev.stopPropagation();
                const track = $(ev.target).closest('.slick-track');
                const slide = $(ev.target).closest('.slick-slide');
                const index = track.children().index(slide);
                $(ev.target).closest('.slick-slider').slick('slickRemove', index);
                savedSearchService.removeSavedSearch(s.SavedSearchId);

                //filtering out searches from the result set
                scope.searches = scope.searches.filter(item => item.SavedSearchId !== s.SavedSearchId);
            };
        }
    };
});
})();
